import { render, staticRenderFns } from "./CompiledBidElements.vue?vue&type=template&id=891be184"
import script from "./CompiledBidElements.vue?vue&type=script&lang=js"
export * from "./CompiledBidElements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports